import SuppliersPage from '@components/containers/suppliers';
import AppLayout from '@layouts/AppLayout';
import type { FC } from 'react';

const Suppliers: FC = () => {
    return (
        <AppLayout>
            <SuppliersPage />
        </AppLayout>
    );
};

export default Suppliers;
